"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldDate = exports.ModelMutatorDate = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var collection_field_1 = require("../collection.field");
var ModelMutatorDate = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorDate, _super);
    function ModelMutatorDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorDate.prototype.manual = function (newValue) {
        this.state.setFieldValue(this.field.id, newValue);
    };
    return ModelMutatorDate;
}(collection_field_1.ModelMutator));
exports.ModelMutatorDate = ModelMutatorDate;
var CollectionModelFieldDate = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldDate, _super);
    function CollectionModelFieldDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldDate.isDateField = function (f) {
        return f.schema.type === CollectionModelFieldDate.TYPE;
    };
    Object.defineProperty(CollectionModelFieldDate.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorDate(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldDate.prototype, "value", {
        get: function () {
            return this.stateValue;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldDate.prototype.hasValue = function () {
        var value = this.value;
        if (value == null || value === '') {
            return false;
        }
        return true;
    };
    CollectionModelFieldDate.TYPE = core_api_1.IkeFieldType.DATE;
    return CollectionModelFieldDate;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldDate = CollectionModelFieldDate;
//# sourceMappingURL=date.field.js.map